import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { Link } from "react-router-dom";
import FAIcon from "../../UI/FAIcon/FAIcon";
const CampaignSidebarItem = (props) => {
    return (_jsx("div", { className: "p-sidebar-item" + (props.active ? " active" : ""), children: _jsx(Link, { className: "p-sidebar-item-title", to: props.to, children: _jsxs("button", { className: "btn btn-link", title: props.title, tabIndex: -1, children: [_jsx(FAIcon, { icon: props.icon, addMarginRight: true, fixedWidth: true, className: "mr-2" }), _jsx("span", { className: "p-sidebar-hide-on-close", children: props.title })] }) }) }));
};
export default CampaignSidebarItem;
